import { render, staticRenderFns } from "./bottom-ota.vue?vue&type=template&id=1a7d899d&scoped=true&"
import script from "./bottom-ota.vue?vue&type=script&lang=js&"
export * from "./bottom-ota.vue?vue&type=script&lang=js&"
import style0 from "./bottom-ota.vue?vue&type=style&index=0&id=1a7d899d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7d899d",
  null
  
)

export default component.exports